import { useSelector } from 'react-redux';
import { useCallback } from 'react';

export const useListOldReduxContainer = (listData, oldMapStateToProps, getData, otherDeps = []) => {
  const state = useSelector((state) => state);

  return useCallback(
    (index) => {
      if (index < 0) {
        return {};
      }

      const cardData = listData[index];
      const props = oldMapStateToProps(state, { cardData });
      return getData({
        cardData,
        ...props,
      });
    },
    [state, listData, oldMapStateToProps, ...otherDeps],
  );
};
